module.exports = __webpack_public_path__ + "static/media/koryu_00028.7c7fa7db.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_00028.png
// module id = 233
// module chunks = 0